import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { ITranscriptAskRequest, ITranscriptAskResponse } from '../../../viewmodels/CalendarViewModels';

export function useAdminTranscriptAskMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: ITranscriptAskRequest) => {
			return userSession.webServiceHelper.callAsync<ITranscriptAskResponse>(
				'admin/zoom/transcripts/ask',
				'POST',
				request
			);
		},
	});
}
